import { useMutation } from '@tanstack/react-query';
import { publicProposalApi } from '@/api/commercial/public-proposal';

export function useRefuseProposal() {
  return useMutation({
    mutationFn: ({ token, justification }: { token: string; justification: string }) =>
      publicProposalApi.refuse(token, justification),
  });
}
